import { render, staticRenderFns } from "./buttonApp.vue?vue&type=template&id=97f7bab4&"
import script from "./buttonApp.vue?vue&type=script&lang=js&"
export * from "./buttonApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports